import { render, staticRenderFns } from "./ColumnForm.vue?vue&type=template&id=3cec36b1&scoped=true"
import script from "./ColumnForm.vue?vue&type=script&lang=js"
export * from "./ColumnForm.vue?vue&type=script&lang=js"
import style0 from "./ColumnForm.vue?vue&type=style&index=0&id=3cec36b1&prod&lang=scss&scoped=true"
import style1 from "./ColumnForm.vue?vue&type=style&index=1&id=3cec36b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cec36b1",
  null
  
)

export default component.exports